export const comagicMixin = {
    methods: {
        /**
         * Проверяет доступность Comagic трекера на сайте
         * @returns {boolean} - Доступен ли Comagic
         */
        isComagicAvailable() {
            try {
                // Проверка наличия объектов Comagic
                if (
                    typeof window.Comagic !== 'undefined' ||
                    typeof window.addOfflineRequest !== 'undefined'
                ) {
                    return true;
                }

                return false;
            } catch (e) {
                console.warn('Ошибка при проверке доступности Comagic:', e);
                return false;
            }
        },

        /**
         * Отправляет данные в Comagic
         * @param {Object} sourceData - Исходные данные формы
         * @returns {boolean} - Результат отправки данных
         */
        sendToComagic(sourceData) {
            console.log('ghg', sourceData);
            // Проверяем доступность Comagic
            if (!this.isComagicAvailable()) {
                console.warn('Comagic недоступен. Данные не отправлены.');
                return false;
            }

            try {
                // Отправляем данные в Comagic
                if (
                    typeof window.Comagic !== 'undefined' &&
                    typeof window.Comagic.addOfflineRequest === 'function'
                ) {
                    // Используем метод addOfflineRequest из Comagic
                    window.Comagic.addOfflineRequest({ sourceData });
                    return true;
                } else {
                    console.warn(
                        'API Comagic найден, но метод addOfflineRequest недоступен.'
                    );
                    return false;
                }
            } catch (e) {
                console.warn('Ошибка при отправке данных в Comagic:', e);
                return false;
            }
        },
    },
};
